export const srLatn = {
  app: { name: 'SprintDeck', tagline: 'Prezentacije čiji tok bira publika' },
  common: {
    save: 'Sačuvaj',
    saving: 'Čuvanje…',
    cancel: 'Otkaži',
    close: 'Zatvori',
    delete: 'Obriši',
    archive: 'Arhiviraj',
    edit: 'Izmeni',
    create: 'Napravi',
    add: 'Dodaj',
    remove: 'Ukloni',
    back: 'Nazad',
    retry: 'Pokušaj ponovo',
    loading: 'Učitavanje…',
    search: 'Pretraga',
    minutes: 'min',
    seconds: 's',
    optional: 'opciono',
    none: 'Nema',
    confirm: 'Potvrdi',
    copy: 'Kopiraj',
    open: 'Otvori',
    slides_one: '{{count}} slajd',
    slides_few: '{{count}} slajda',
    slides_other: '{{count}} slajdova',
  },
  nav: {
    presentations: 'Prezentacije',
    topics: 'Sekcije',
    assets: 'Fajlovi',
    account: 'Nalog',
    logout: 'Odjavi se',
    theme: 'Tema',
    themeLight: 'Svetla',
    themeDark: 'Tamna',
    themeSystem: 'Sistemska',
    language: 'Jezik',
    mainNavigation: 'Glavna navigacija',
    sessions: 'Predavanja',
    users: 'Korisnici',
  },
  auth: {
    loginTitle: 'Dobro došli nazad',
    loginSubtitle: 'Prijavite se da biste upravljali prezentacijama.',
    registerTitle: 'Napravite nalog predavača',
    registerSubtitle: 'Nalog odobrava administrator. Publici nalog nije potreban.',
    pendingTitle: 'Zahtev je poslat',
    pendingBody:
      'Administrator treba da odobri vaš nalog. Kada ga odobri, prijavite se emailom i lozinkom koje ste uneli.',
    email: 'Email adresa',
    password: 'Lozinka',
    passwordHint: 'Najmanje 10 znakova.',
    displayName: 'Ime i prezime',
    login: 'Prijavi se',
    register: 'Napravi nalog',
    noAccount: 'Nemate nalog?',
    haveAccount: 'Već imate nalog?',
    goRegister: 'Registrujte se',
    goLogin: 'Prijavite se',
    heroTitle: 'Publika bira Sprint. Vi vodite predavanje.',
    heroBody:
      'Sekcije su Product Backlog, svaka anketa je Sprint Planning, a tajmer čuva timebox. Učesnici glasaju telefonom, bez registracije.',
    heroPoint1: 'Uvoz PDF i PowerPoint slajdova',
    heroPoint2: 'Glasanje uživo preko QR koda',
    heroCardIdea: 'Ideja',
    heroCardTeam: 'Tim',
    heroCardMarket: 'Tržište',
    heroCardMoney: 'Finansije',
    heroPoint3: 'Animirani prelazak napred i nazad',
  },
  account: {
    title: 'Nalog',
    subtitle: 'Lični podaci, jezik interfejsa i lozinka.',
    profile: 'Profil',
    locale: 'Jezik interfejsa',
    changePassword: 'Promena lozinke',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    passwordChanged: 'Lozinka je promenjena. Ostale sesije su odjavljene.',
    saved: 'Podaci su sačuvani.',
  },
  errors: {
    NOTHING_TO_UNDO: 'Nema izmene za poništavanje.',
    NOTHING_TO_REDO: 'Nema izmene za ponavljanje.',
    ASSET_NOT_FAILED: 'Ponovo se konvertuje samo fajl čija konverzija nije uspela.',
    COLLECTION_NAME_TAKEN: 'Oblast sa tim imenom već postoji.',
    DYNAMIC_POLL_REQUIRED: 'Dinamička anketa ne može da se obriše. Možete je isključiti u tabu „Ankete".',
    INTRO_REQUIRED: 'Uvod ne može da se ukloni iz prezentacije.',
    JOIN_CODE_TAKEN: 'Taj kod već koristi drugo predavanje.',
    NO_LIBRARY_TOPIC: 'Ova sekcija nema izvornu sekciju u biblioteci.',
    NOT_PUBLISHED: 'Prvo sačuvajte prezentaciju, pa pokrenite predavanje.',
    PAIRING_EXPIRED: 'Kod za uparivanje je istekao ili je već iskorišćen. Zatražite novi u konzoli.',
    SESSION_ACTIVE: 'Predavanje je u toku. Završite ga pa obrišite izveštaj.',
    SESSION_FULL: 'Predavanje je dostiglo najveći broj učesnika.',
    TOPIC_ALREADY_ADDED: 'Ova sekcija je već u prezentaciji.',
    TOPIC_ARCHIVED: 'Arhivirana sekcija ne može da se doda. Prvo je vratite iz arhive.',
    TOPIC_IN_USE:
      'Sekcija se koristi u prezentaciji, pa ne može da se obriše. Arhivirajte je ili je prvo uklonite iz prezentacija.',
    UNKNOWN_COLLECTION: 'Oblast ne postoji ili je obrisana.',
    PRESENTATION_LIVE: 'Predavanje ove prezentacije je u toku. Završite ga pa obrišite prezentaciju.',
    ASSET_IN_USE: 'Slajdovi iz ovog fajla se koriste, pa fajl ne može da se obriše.',
    ASSET_PROCESSING: 'Sačekajte da se konverzija završi.',
    INVALID_CREDENTIALS: 'Pogrešan email ili lozinka.',
    EMAIL_TAKEN: 'Nalog sa ovim emailom već postoji.',
    RATE_LIMITED: 'Previše pokušaja. Sačekajte minut pa pokušajte ponovo.',
    VALIDATION_FAILED: 'Proverite unete podatke.',
    WRONG_PASSWORD: 'Trenutna lozinka nije tačna.',
    REGISTRATION_CLOSED: 'Registracija je trenutno isključena.',
    SURVEY_PLACEMENT_INVALID: 'Izabrani slajd nije u toj sekciji.',
    SURVEY_PLACEMENT_TAKEN: 'Posle ovog slajda je već drugi upitnik.',
    SURVEY_CLOSED: 'Upitnik je zatvoren.',
    UNKNOWN_SURVEY: 'Upitnik nije pronađen.',
    INVALID_ANSWER: 'Odgovor nije ispravan.',
    ANSWER_TOO_LONG: 'Odgovor je predugačak.',
    EMPTY_ANSWER: 'Upišite ili izaberite odgovor.',
    TOO_MANY_OPTIONS: 'Izabrano je previše odgovora.',
    UNKNOWN_OPTION: 'Odgovor više ne postoji.',
    TOO_MANY_SURVEYS: 'Prezentacija može da ima najviše 30 upitnika.',
    SESSION_COMPLETED: 'Predavanje je završeno.',
    ACCOUNT_PENDING: 'Nalog još čeka odobrenje administratora.',
    ACCOUNT_DISABLED: 'Nalog je deaktiviran. Obratite se administratoru.',
    ADMIN_ONLY: 'Ovo mogu samo administratori.',
    LAST_ADMIN: 'Mora da ostane bar jedan aktivan administrator.',
    CANNOT_CHANGE_SELF: 'Ovo ne možete da uradite sa sopstvenim nalogom.',
    USER_NOT_APPROVED: 'Prvo odobrite nalog.',
    USER_ALREADY_APPROVED: 'Nalog je već odobren.',
    USER_HAS_LIVE_SESSION: 'Korisnik upravo drži predavanje. Pokušajte kad ga završi.',
    CONFIRM_EMAIL_MISMATCH: 'Uneti email se ne poklapa sa nalogom.',
    NETWORK: 'Server nije dostupan. Proverite vezu.',
    VERSION_CONFLICT: 'Neko je u međuvremenu izmenio podatke. Prikazana je najnovija verzija.',
    PAYLOAD_TOO_LARGE: 'Fajl je prevelik.',
    NOT_FOUND: 'Traženi podatak ne postoji.',
    generic: 'Nešto nije u redu. Pokušajte ponovo.',
  },
  assets: {
    title: 'Fajlovi',
    subtitle: 'PDF i PowerPoint dokumenti iz kojih birate slajdove.',
    upload: 'Uploaduj fajl',
    dropTitle: 'Prevucite PDF, ili PPTX zajedno sa njegovim PDF-om',
    dropBody: 'ili kliknite da izaberete fajlove. Najviše {{size}} MB po fajlu.',
    uploading: 'Slanje {{percent}}%',
    emptyTitle: 'Još nema fajlova',
    emptyBody:
      'Uploadujte prvu prezentaciju. Svaka stranica postaje slajd koji možete da koristite u više sekcija.',
    status: { QUEUED: 'Na čekanju', PROCESSING: 'Obrada', READY: 'Spremno', FAILED: 'Greška' },
    processingPages: 'Obrađeno stranica: {{count}}',
    usedIn_one: 'Koristi se u {{count}} sekciji',
    usedIn_few: 'Koristi se u {{count}} sekcije',
    usedIn_other: 'Koristi se u {{count}} sekcija',
    notUsed: 'Nije u upotrebi',
    showArchived: 'Prikaži arhivirane',
    archived: 'Arhivirano',
    unarchive: 'Vrati iz arhive',
    deleteTitle: 'Obrisati fajl?',
    deleteBody: 'Fajl i njegovi slajdovi biće trajno obrisani.',
    deleted: 'Fajl je obrisan.',
    inUseTitle: 'Fajl se koristi',
    inUseBody:
      'Slajdovi iz ovog fajla se koriste, pa fajl još ne može da se obriše. Uklonite slajdove sa ovih mesta ili arhivirajte fajl: arhiviran fajl se više ne nudi pri izboru slajdova, a prezentacije koje ga koriste i dalje rade.',
    inUseSavedVersions:
      'Sačuvane verzije zadržavaju slajdove zbog izveštaja i ponovnog pokretanja. Fajl se oslobađa tek kad se te prezentacije trajno obrišu.',
    checkingUsage: 'Proveravam gde se fajl koristi…',
    archivedToast: 'Fajl je arhiviran.',
    usage: {
      topics: 'Sekcije',
      presentations: 'Prezentacije',
      savedVersions: 'Sačuvane verzije prezentacija',
    },
    chooseFiles: 'Izbor fajlova',
    onePowerPointAtATime: 'Pošaljite jedan PowerPoint fajl odjednom, zajedno sa njegovim PDF-om.',
    pdfNeededTitle: 'Potreban je i PDF',
    pdfNeededBody:
      'U PowerPoint-u otvorite isti fajl i izaberite File > Export > PDF, pa ovde prevucite ili izaberite taj PDF. Mora da ima onoliko strana koliko PowerPoint ima vidljivih slajdova. Slajdovi se prikazuju iz PDF-a, a iz PowerPoint-a se uzimaju beleške.',
    choosePdf: 'Izaberi PDF',
    uploaded: 'Fajl je primljen. Konverzija je u toku.',
    limitationsTitle: 'PowerPoint fajlovi',
    limitationsBody:
      'Uz PowerPoint fajl pošaljite i PDF izvezen iz PowerPoint-a (File > Export > PDF). Slajdovi se prikazuju iz PDF-a, sa vašim fontovima, a iz PPTX-a se uzimaju samo beleške; PPTX se ne čuva. Animacije, prelazi, video, zvuk i interaktivni elementi se ne prikazuju, slajd je slika.',
    errors: {
      PDF_REQUIRED: 'Uz PowerPoint fajl pošaljite i PDF izvezen iz PowerPoint-a.',
      PAIR_INVALID: 'Pošaljite jedan PowerPoint fajl i njegov PDF.',
      PAGE_COUNT_MISMATCH:
        'PDF ima {{pages}} strana, a PowerPoint {{slides}} vidljivih slajdova. Izvezite PDF ponovo iz istog fajla, bez skrivenih slajdova i bez stranica sa beleškama.',
      UNSUPPORTED_TYPE: 'Podržani su samo PDF i PPTX fajlovi.',
      MACRO_ENABLED: 'Fajl sadrži makroe. Sačuvajte ga kao običan .pptx.',
      ENCRYPTED: 'Fajl je zaštićen lozinkom ili je u starom formatu.',
      ZIP_BOMB: 'Fajl se raspakuje u nebezbednu veličinu.',
      CORRUPT: 'Fajl je oštećen.',
      EMPTY_FILE: 'Fajl je prazan.',
      TOO_MANY_PAGES: 'Dokument ima previše stranica.',
      TIMEOUT: 'Konverzija je trajala predugo.',
      CONVERSION_FAILED: 'Konverzija nije uspela.',
      INTERNAL: 'Greška servera tokom konverzije.',
    },
    slides: 'Slajdovi',
  },
  topics: {
    title: 'Sekcije',
    subtitle: 'Biblioteka sekcija. Jedna sekcija može da se koristi u više prezentacija.',
    create: 'Nova sekcija',
    emptyTitle: 'Još nema sekcija',
    emptyBody: 'Sekcija je jedan Sprint: naslov, kratak opis i nekoliko slajdova.',
    name: 'Naziv sekcije',
    description: 'Kratak opis',
    color: 'Boja',
    icon: 'Ikonica',
    duration: 'Procena trajanja',
    durationHint: 'U minutima',
    slides: 'Slajdovi sekcije',
    addSlides: 'Dodaj slajdove',
    noSlides: 'Sekcija još nema slajdove.',
    noSlidesBody: 'Dodajte slajdove iz uploadovanih fajlova.',
    usedIn_one: 'U {{count}} prezentaciji',
    usedIn_few: 'U {{count}} prezentacije',
    usedIn_other: 'U {{count}} prezentacija',
    dragHint: 'Prevucite kartice da promenite redosled.',
    saved: 'Sekcija je sačuvana.',
    copy: 'Kopiraj',
    copyTitle: '{{title}} (kopija)',
    copied: 'Kopija sekcije je napravljena.',
    deleteTitle: 'Obrisati sekciju?',
    deleteBody: 'Sekcija će biti trajno obrisana iz biblioteke.',
    archiveInsteadBody: 'Sekcija se koristi u prezentaciji, pa je možete samo arhivirati.',
    removeSlide: 'Ukloni slajd',
    moveSlide: 'Pomeri slajd',
    back: 'Sve sekcije',
  },
  slideNotes: {
    title: 'Beleške uz slajd {{position}} od {{count}}',
    hint: 'Beleške vidite samo vi: u konzoli, na telefonu predavača i u pregledu. Projektor i publika ih ne vide.',
    label: 'Beleške',
    placeholder: 'Šta želite da kažete uz ovaj slajd',
    counter: '{{count}} od {{max}} znakova',
    previous: 'Prethodni',
    next: 'Sledeći',
    slide: 'Slajd {{position}}',
    open: 'Beleške uz slajd {{position}}',
    openWithNotes: 'Beleške uz slajd {{position}}, ima beleške',
    saveFailed: 'Beleške nisu sačuvane. Pokušajte ponovo.',
    show: 'Prikaži beleške',
    hide: 'Sakrij beleške',
    heading: 'Beleške',
    empty: 'Ovaj slajd nema beleške.',
  },
  history: {
    undo: 'Poništi poslednju izmenu ({{shortcut}})',
    redo: 'Ponovi poništenu izmenu ({{shortcut}})',
  },
  picker: {
    scope: 'Koji fajlovi',
    thisCollection: 'Ova oblast',
    allFiles: 'Svi fajlovi',
    title: 'Izbor slajdova',
    titleFor: 'Izbor slajdova za: {{target}}',
    description:
      'Kliknite slajdove redom kojim želite da se prikazuju. Shift i klik biraju sve slajdove između dva klika.',
    files: 'Fajlovi',
    noReadyFiles: 'Nema spremnih fajlova. Prvo uploadujte PDF ili PPTX.',
    selected_one: 'Izabran {{count}} slajd',
    selected_few: 'Izabrana {{count}} slajda',
    selected_other: 'Izabrano {{count}} slajdova',
    add: 'Dodaj izabrane',
    selectAll: 'Izaberi sve',
    alreadyAdded: 'Već dodat',
  },
  presentations: {
    title: 'Prezentacije',
    subtitle: 'Sastavite backlog sekcija, pripremite ankete i sačuvajte verziju za predavanje.',
    create: 'Nova prezentacija',
    createTitle: 'Nova prezentacija',
    name: 'Naziv',
    description: 'Opis',
    duration: 'Trajanje predavanja',
    emptyTitle: 'Još nema prezentacija',
    emptyBody: 'Napravite prezentaciju i dodajte sekcije iz biblioteke.',
    draft: 'Nacrt',
    published: 'Sačuvana verzija {{version}}',
    unpublished: 'Izmene nisu sačuvane',
    topics_one: '{{count}} sekcija',
    topics_few: '{{count}} sekcije',
    topics_other: '{{count}} sekcija',
    polls_one: '{{count}} anketa',
    polls_few: '{{count}} ankete',
    polls_other: '{{count}} anketa',
    minutes: '{{count}} min',
    copy: 'Napravi kopiju',
    copyTitle: '{{title}} (kopija)',
    copied: 'Kopija je napravljena.',
    archiveDone: 'Prezentacija je arhivirana.',
    deleteForever: 'Obriši trajno',
    deleteTitle: 'Trajno obrisati „{{title}}"?',
    deleteBody:
      'Brišu se prezentacija, sve njene sačuvane verzije i izveštaji njenih predavanja. Ovo ne može da se vrati. Sekcije i fajlovi u biblioteci ostaju.',
    deleteTalks_one: 'Briše se i izveštaj {{count}} održanog predavanja.',
    deleteTalks_few: 'Brišu se i izveštaji {{count}} održana predavanja.',
    deleteTalks_other: 'Brišu se i izveštaji {{count}} održanih predavanja.',
    deleted: 'Prezentacija je trajno obrisana.',
    showArchived: 'Prikaži arhivirane',
    updated: 'Izmenjeno {{date}}',
  },
  builder: {
    tabs: { backlog: 'Backlog', polls: 'Ankete', settings: 'Podešavanja' },
    preview: 'Pregled',
    publish: 'Sačuvaj',
    published: 'Sačuvana je verzija {{version}}.',
    notChanged: 'Nema izmena od poslednjeg čuvanja.',
    backlogTitle: 'Product Backlog',
    backlogHint:
      'Ovo je osnovni redosled sekcija. Stvarni redosled tokom predavanja bira publika glasanjem, a prelazak napred ili nazad se računa prema ovom redosledu.',
    intro: 'Uvod',
    introHint: 'Naslovni i uvodni slajdovi. Ako ih nema, prikazuje se generisana naslovna strana.',
    conclusion: 'Zaključak',
    conclusionHint:
      'Posebna sekcija koja se prikazuje na kraju ili kada istekne vreme. Ne nudi se u anketama.',
    setConclusion: 'Izaberi zaključak',
    replaceConclusion: 'Zameni',
    addTopic: 'Dodaj sekciju',
    addTopicTitle: 'Dodaj sekciju iz biblioteke',
    noTopicsLeft: 'Sve sekcije iz biblioteke su već dodate.',
    createTopicHint: 'Napravite novu sekciju u biblioteci.',
    editSlides: 'Slajdovi',
    resetSlides: 'Vrati slajdove iz biblioteke',
    removeSection: 'Ukloni iz prezentacije',
    sectionSettings: 'Podešavanja sekcije',
    titleOverride: 'Naslov u ovoj prezentaciji',
    titleOverrideHint: 'Prazno znači naslov iz biblioteke: {{title}}',
    durationOverride: 'Trajanje u ovoj prezentaciji (min)',
    position: 'Pozicija {{position}}',
    estimated: 'Procena: {{estimated}} od {{total}} min',
    slidesEditorTitle: 'Slajdovi: {{title}}',
    slidesEditorHint: 'Izbor važi samo za ovu prezentaciju. Biblioteka ostaje nepromenjena.',
    noSlides: 'Nema slajdova',
    slidesFor: 'Slajdovi: {{title}} ({{count}})',
    archivedTopic: 'Sekcija je arhivirana',
    conflict: 'Prezentacija je izmenjena u drugom prozoru. Učitana je najnovija verzija.',
  },
  polls: {
    title: 'Ankete',
    subtitle: 'Svaka anketa je Sprint Planning. Odgovori vode na sekcije iz backloga.',
    dynamicTitle: 'Dinamička anketa',
    dynamicEnabled: 'Posle svake sekcije',
    dynamicOffBody:
      'Isključena. Posle sekcije se otvara samo pripremljena anketa predložena za tu sekciju; ako je nema, sledeća sekcija iz backloga kreće sama, a posle poslednje Zaključak.',
    dynamicBody:
      'Automatski nudi sve sekcije koje publika još nije slušala, redom iz backloga. Koristi se kada nije izabrana pripremljena anketa.',
    dynamicDefaultQuestion: 'O čemu želite da razgovaramo u narednom Sprintu?',
    staticTitle: 'Pripremljene ankete',
    create: 'Nova anketa',
    edit: 'Izmena ankete',
    question: 'Pitanje',
    options: 'Odgovori',
    option: 'Odgovor {{index}}',
    optionLabel: 'Tekst odgovora',
    target: 'Vodi na sekciju',
    chooseTarget: 'Izaberite sekciju',
    addOption: 'Dodaj odgovor',
    initial: 'Početna anketa',
    initialHint: 'Otvara se posle uvoda.',
    suggestAfter: 'Predloži posle sekcije',
    suggestAfterNone: 'Bez predloga',
    duration: 'Automatsko zatvaranje (sekunde)',
    durationHint: 'Prazno znači da predavač ručno zatvara anketu.',
    emptyTitle: 'Nema pripremljenih anketa',
    emptyBody: 'Dinamička anketa pokriva sve slučajeve, a pripremljena anketa daje vaša pitanja i odgovore.',
    sameTargetHint: 'Više odgovora može da vodi na istu sekciju; glasovi se tada sabiraju.',
    previewTitle: 'Šta publika vidi',
    previewHint: 'Označite sekcije koje su već obrađene da vidite koje opcije ostaju.',
    previewInsufficient:
      'Ostaje manje od dva odgovora. Glasanje se ne pokreće; predavač bira sekciju ili zaključak.',
    deleteTitle: 'Obrisati anketu?',
    deleteBody: 'Anketa i njeni odgovori biće obrisani iz nacrta.',
    unlinked: 'Odgovor nije povezan sa sekcijom',
    initialBadge: 'Početna',
    afterBadge: 'Posle: {{topic}}',
    autoClose: 'Zatvara se posle {{seconds}} s',
  },
  settings: {
    timeboxTitle: 'Timebox',
    duration: 'Trajanje predavanja (minuti)',
    warnings: 'Upozorenja pre isteka (sekunde, razdvojeno zarezom)',
    repeatTitle: 'Ponavljanje sekcija',
    repeat: {
      NEVER: 'Obrađene sekcije se ne nude ponovo',
      ALWAYS: 'Obrađene sekcije mogu ponovo da se nude',
      PRESENTER_CONTROLLED: 'Predavač uključuje ponavljanje tokom predavanja',
    },
    repeatHint: {
      NEVER: 'Najčešći izbor: svaka sekcija se sluša jednom.',
      ALWAYS: 'Publika može da traži istu sekciju više puta.',
      PRESENTER_CONTROLLED: 'Podrazumevano kao prvo pravilo, uz ručne izuzetke.',
    },
    transitionsTitle: 'Animacija prelaska',
    transitionsEnabled: 'Prikaži premotavanje slajdova',
    transitionSpeed: 'Trajanje prelaska: {{seconds}} s',
    flowTitle: 'Tok predavanja',
    afterTopicEnd: 'Posle završene sekcije',
    afterTopicEndOptions: {
      AUTO_OPEN_SUGGESTED_POLL: 'Pripremi predloženu anketu',
      SHOW_BACKLOG: 'Prikaži backlog predavaču',
    },
    resultsVisibility: 'Rezultati na projektoru',
    resultsOptions: { LIVE: 'Uživo tokom glasanja', AFTER_CLOSE: 'Posle zatvaranja', HIDDEN: 'Ne prikazuj' },
    audienceSeesResults: 'Učesnici vide rezultate na telefonu',
    sprintReviewTitle: 'Zaključak',
    sprintReviewEnabled: 'Slajd „Šta smo isporučili" u Zaključku',
    sprintReviewHint:
      'Aplikacija sama pravi slajd: isporučene sekcije sa kvačicom, započete sa oznakom, a ispod one koje su ostale u backlogu.',
    sprintReviewPosition: 'Mesto u Zaključku',
    sprintReviewFirst: 'Na početku Zaključka',
    sprintReviewAfter: 'Posle slajda {{position}} Zaključka',
    engagementTitle: 'Interakcija publike',
    reactionsEnabled: 'Reakcije na slajdove',
    questionsEnabled: 'Anonimna pitanja',
    saved: 'Podešavanja su sačuvana.',
  },
  validation: {
    title: 'Spremnost za čuvanje',
    ready: 'Spremno za čuvanje',
    notReady_one: '{{count}} problem sprečava čuvanje',
    notReady_few: '{{count}} problema sprečavaju čuvanje',
    notReady_other: '{{count}} problema sprečava čuvanje',
    warnings: 'Upozorenja',
    codes: {
      NO_CONCLUSION: 'Izaberite sekciju Zaključak.',
      NO_REGULAR_TOPICS: 'Dodajte bar jednu sekciju u backlog.',
      SECTION_NO_SLIDES: 'Sekcija „{{section}}" nema slajdove.',
      SLIDE_ARCHIVED: 'Sekcija „{{section}}" koristi slajd iz arhiviranog fajla.',
      TOPIC_ARCHIVED: 'Sekcija „{{section}}" je arhivirana u biblioteci.',
      OPTION_UNLINKED: 'Anketa „{{poll}}" ima odgovor bez sekcije.',
      OPTION_TARGET_NOT_VOTEABLE: 'Anketa „{{poll}}" vodi na sekciju koja ne može da se bira.',
      POLL_LT_2_TARGETS: 'Anketa „{{poll}}" mora da vodi na bar dve različite sekcije.',
      POLL_NO_QUESTION: 'Anketa nema pitanje.',
      INVALID_DURATION: 'Trajanje predavanja nije ispravno.',
      DURATION_EXCEEDED: 'Procena trajanja sekcija premašuje timebox.',
      SINGLE_REGULAR_TOPIC: 'Sa jednom sekcijom nema glasanja.',
      SURVEY_NO_QUESTIONS: 'Upitnik „{{survey}}" nema pitanja.',
      SURVEY_FEW_OPTIONS: 'Pitanje u upitniku „{{survey}}" ima manje od dva odgovora.',
      SURVEY_QUIZ_NO_CORRECT: 'Kviz u upitniku „{{survey}}" nema označen tačan odgovor.',
      SURVEY_PLACEMENT_MISSING: 'Upitnik „{{survey}}" je vezan za slajd koji više ne postoji.',
      SURVEY_PLACEMENT_DUPLICATE: 'Upitnik „{{survey}}" je na istom mestu kao drugi upitnik.',
    },
  },
  preview: {
    title: 'Pregled prezentacije',
    draft: 'Nacrt',
    revision: 'Verzija {{version}}',
    keyboardHint: 'Strelice levo i desno menjaju slajd. Escape zatvara pregled.',
    exit: 'Zatvori pregled',
    slideOf: 'Slajd {{current}} od {{total}}',
    generatedTitle: 'Generisana naslovna strana',
  },
  live: {
    start: 'Pokreni predavanje',
    startHint: 'Predavanje koristi sačuvanu verziju {{version}}.',
    startNeedsPublish: 'Prvo sačuvajte prezentaciju.',
    resumeSession: 'Nastavi predavanje',
    console: 'Konzola predavača',
    joinCode: 'Kod',
    joinAt: 'Priključite se na',
    connectAt: 'Poveži se: {{address}}',
    scanToJoin: 'Skenirajte QR kod ili otvorite {{url}} i unesite kod',
    participants_one: '{{count}} učesnik',
    participants_few: '{{count}} učesnika',
    participants_other: '{{count}} učesnika',
    votes_one: '{{count}} glas',
    votes_few: '{{count}} glasa',
    votes_other: '{{count}} glasova',
    connection: {
      connected: 'Povezano',
      connecting: 'Povezivanje…',
      reconnecting: 'Ponovno povezivanje…',
      offline: 'Nema veze',
    },
    timeSetup: {
      title: 'Koliko traje predavanje?',
      hint: 'Prevucite po krugu ili izaberite trajanje. Odbrojavanje kreće kada kliknete „Kreni".',
      projectorTitle: 'Vreme za predavanje',
      projectorHint: 'Predavač podešava trajanje',
      dial: 'Trajanje predavanja',
      minutes_one: '{{count}} minut',
      minutes_few: '{{count}} minuta',
      minutes_other: '{{count}} minuta',
      minutesShort_one: '{{count}} min',
      minutesShort_few: '{{count}} min',
      minutesShort_other: '{{count}} min',
      less: 'Pet minuta manje',
      more: 'Pet minuta više',
      go: 'Kreni',
      waiting: 'Predavač podešava vreme. Počinjemo za trenutak.',
    },
    sprintReview: {
      eyebrow: 'Sprint Review',
      title: 'Šta smo isporučili',
      started: 'započeto',
      deliveredItem: 'isporučeno',
      backlog: 'Ostalo u backlogu',
      nothingDelivered: 'Nijedna sekcija još nije obrađena.',
      allDelivered: 'Sve sekcije iz backloga su isporučene.',
    },
    joinCodePicker: {
      title: 'Izbor koda',
      open: 'Promeni kod',
      warning: 'Posle promene stari link i QR kod više ne rade. Ko je već povezan ostaje povezan.',
      suggestions: 'Predlozi',
      generate: 'Generiši nove',
      custom: 'Kod koji želite',
      customHint: 'Šest znakova: slova bez I i O, brojevi od 2 do 9.',
      apply: 'Postavi kod',
      changed: 'Novi kod je {{code}}.',
      taken: 'Taj kod već koristi drugo predavanje. Izaberite drugi.',
      completed: 'Završeno predavanje zadržava svoj kod.',
      failed: 'Kod nije promenjen. Pokušajte ponovo.',
      loadFailed: 'Predlozi nisu učitani.',
    },
    joinOverlay: {
      show: 'Prikaži kod na projektoru',
      hide: 'Skloni kod sa projektora',
    },
    modes: {
      NOT_STARTED: 'Spremno za početak',
      INTRO: 'Uvod',
      TIME_SETUP: 'Podešavanje vremena',
      BACKLOG: 'Backlog',
      POLL: 'Glasanje u toku',
      RESULTS: 'Rezultati',
      TOPIC: 'Sprint u toku',
      CONCLUSION: 'Zaključak',
      COMPLETED: 'Predavanje je završeno',
    },
    startSession: 'Započni',
    endSession: 'Završi predavanje',
    endSessionConfirm: 'Završiti predavanje? Učesnici više neće moći da glasaju.',
    openProjector: 'Otvori projektor',
    projectorElsewhere: 'Projektor na drugom računaru',
    remote: 'Upravljaj sa telefona',
    remoteTitle: 'Daljinski upravljač',
    remoteBody: 'Skenirajte kod telefonom. Kod važi dva minuta i može se iskoristiti jednom.',
    projectorPairBody: 'Otvorite ovu adresu na računaru projektora. Važi dva minuta i jednom.',
    pairingExpires: 'Ističe za {{seconds}} s',
    newCode: 'Novi kod',
    devices: 'Upareni uređaji',
    noDevices: 'Nema uparenih uređaja.',
    revoke: 'Odjavi',
    online: 'na vezi',
    offlineDevice: 'van veze',
    previous: 'Prethodni',
    next: 'Sledeći',
    slideOf: '{{current}} / {{total}}',
    nextSlide: 'Sledeći slajd',
    lastSlide: 'Poslednji slajd sekcije',
    endTopic: 'Završi sekciju',
    conclusion: 'Zaključak',
    goConclusion: 'Pređi na Zaključak',
    backlog: 'Product Backlog',
    status: { NOT_PRESENTED: 'Neobrađeno', IN_PROGRESS: 'U toku', COMPLETED: 'Obrađeno' },
    presentedTimes: 'obrađeno {{count}}×',
    audienceValue: 'Vrednost za publiku',
    audienceValueHint:
      'Udeo glasova iz poslednje ankete u kojoj je sekcija ponuđena, preračunat na sekcije koje su još dostupne.',
    noValueYet: 'još nema glasova',
    staleValue: 'iz ranije ankete',
    pollPanel: 'Sprint Planning',
    choosePoll: 'Izaberite anketu',
    suggested: 'Predloženo',
    openPoll: 'Otvori anketu',
    replacePoll: 'Zameni anketu',
    closePoll: 'Zatvori glasanje',
    cancelPoll: 'Otkaži anketu',
    repoll: 'Ponovi glasanje',
    inOrder: 'Sekcije idu redom iz backloga, a posle poslednje počinje Zaključak.',
    insufficient: 'Za glasanje su potrebne bar dve dostupne sekcije.',
    waitingForVotes: 'Čekamo prve glasove',
    winner: 'Pobednik: {{topic}}',
    tie: 'Nerešeno: izaberite jednu od izjednačenih sekcija',
    noVotes: 'Niko nije glasao. Ponovite anketu ili izaberite sekciju.',
    confirm: 'Prihvati: {{topic}}',
    override: 'Izaberi drugu sekciju',
    chooseTopic: 'Izaberite sekciju',
    backlogReasons: {
      AFTER_TOPIC: 'Sekcija je završena. Izaberite anketu ili sledeću sekciju.',
      INSUFFICIENT_OPTIONS: 'Ostala je samo jedna dostupna sekcija. Pređite na nju ili na Zaključak.',
      NO_ELIGIBLE: 'Sve sekcije su obrađene. Vreme je za Zaključak.',
      POLL_CANCELLED: 'Anketa je otkazana.',
    },
    goTo: 'Pređi',
    alreadyPresented: 'Ova sekcija je već obrađena, a ponavljanje nije uključeno. Ipak preći na nju?',
    forceGo: 'Ipak pređi',
    dynamicQuestion: 'O čemu želite da razgovaramo u narednom Sprintu?',
    history: 'Tok predavanja',
    entry: {
      START: 'početak',
      VOTE_WINNER: 'glasanje',
      TIE_BREAK: 'izbor kod nerešenog',
      OVERRIDE: 'ručna izmena',
      MANUAL_NO_VOTES: 'ručno, bez glasova',
      DIRECT: 'ručni izbor',
      IN_ORDER: 'po redu',
      CONCLUSION_MANUAL: 'zaključak',
      CONCLUSION_TIMER: 'zaključak po isteku vremena',
      RESUME: 'nastavak posle zaključka',
    },
    keyboard: 'Strelice menjaju slajd, Z prelazi na Zaključak.',
    timer: {
      title: 'Vreme',
      open: 'Podešavanje vremena',
      reduceBy: 'Oduzmi {{minutes}} min',
      remaining: 'Preostalo vreme',
      paused: 'Pauzirano',
      expired: 'Vreme je isteklo',
      planned: 'planirano {{minutes}} min',
      pause: 'Pauziraj',
      resume: 'Nastavi',
      set: 'Podesi',
      setTitle: 'Preostalo vreme',
      setBody: 'Unesite koliko minuta je preostalo do kraja predavanja.',
      minutes: 'min',
      duration: 'Trajanje',
      warning: 'Preostalo je {{time}}.',
      expiredHint: 'Zaključak je pokrenut. Vreme dodajete pri nastavku predavanja.',
    },
    resume: {
      timerTitle: 'Vreme je isteklo, pokrenut je Zaključak',
      timerBody: 'Sat ostaje na 00:00. Završite Zaključak ili dodajte vreme i nastavite predavanje.',
      manualTitle: 'Zaključak',
      manualBody: 'Možete se vratiti predavanju i bez dodatnog vremena.',
      addTime: 'Dodatno vreme',
      noExtra: 'Bez dodatka',
      previous: 'Nazad na: {{topic}}',
      previousAt: 'Nazad na: {{topic}}, slajd {{slide}}',
      poll: 'Nova anketa',
      backlog: 'Backlog',
    },
    repeat: {
      allow: 'Dozvoli ponavljanje ove sekcije',
      allowed: 'Ponavljanje je dozvoljeno',
    },
    completed: {
      duration: 'Planirano {{planned}} min, održano {{actual}} min.',
      abandoned: 'Predavanje je automatski završeno posle 12 sati bez aktivnosti. ',
      reopen: 'Ponovo otvori ({{time}})',
    },
    reactions: {
      title: 'Reakcije',
      slide: 'Ovaj slajd',
      topic: 'Ova sekcija',
      session: 'Ukupno',
    },
    questions: {
      title: 'Pitanja publike',
      newCount_one: '{{count}} novo',
      newCount_few: '{{count}} nova',
      newCount_other: '{{count}} novih',
      filter: 'Prikaz pitanja',
      filters: { NEW: 'Nova', ANSWERED: 'Odgovorena', HIDDEN: 'Sakrivena', ALL: 'Sva' },
      empty: 'Nema pitanja u ovom prikazu.',
      project: 'Na projektor',
      unproject: 'Skini sa projektora',
      answer: 'Odgovoreno',
      hide: 'Sakrij',
      restore: 'Vrati',
      onProjector: 'na projektoru',
      fromAudience: 'Pitanje iz publike',
    },
    overview: {
      title: 'Pregled backloga',
      columns: { NOT_PRESENTED: 'Neobrađeno', IN_PROGRESS: 'Započeto', COMPLETED: 'Obrađeno' },
      empty: 'Nema sekcija',
      planned: 'Planirani redosled',
      actual: 'Stvarni redosled',
      plannedAt: 'plan #{{position}}',
      interrupted: 'prekinuto',
      nothingPresented: 'Nijedna sekcija nije obrađena.',
    },
    contents: 'Sadržaj',
    controls: 'Kontrole',
    paired: 'Telefon je uparen.',
    pairFailed: 'Kod za uparivanje je istekao ili je već iskorišćen. Zatražite novi u konzoli.',
    pairing: 'Uparivanje…',
    completedTopics: 'Završeno',
    backToSlides: 'Nazad na slajd',
    backToSlidesTitle: 'Vratiti se na slajd?',
    backToSlidesBody:
      'Anketa će biti otkazana, a primljeni glasovi ({{votes}}) biće poništeni. Kad ponovo pređete dalje, otvoriće se nova anketa.',
    questionsTab: 'Pitanja',
    newQuestions: 'Nova pitanja',
    remoteEnded: 'Predavanje je završeno.',
    commandFailed: 'Komanda nije izvršena: {{code}}',
    rejections: {
      NOT_ENOUGH_TIME: 'Mora da ostane bar jedan minut. Za kraj predavanja pređite na Zaključak.',
      NOTHING_TO_RETURN_TO:
        'Anketa nije otvorena odmah posle sekcije, pa nema slajda na koji se može vratiti.',
      MODE_NOT_ALLOWED: 'Ova komanda sada nije dostupna.',
      POLL_NOT_OPEN: 'Glasanje više nije otvoreno.',
      STALE_NAVIGATION: 'Slajd je u međuvremenu promenjen.',
      STALE_STATE: 'Stanje je u međuvremenu promenjeno.',
      INSUFFICIENT_OPTIONS: 'Nema dovoljno dostupnih sekcija za glasanje.',
      NOT_ELIGIBLE: 'Sekcija nije dostupna.',
      END_OF_CONCLUSION: 'Ovo je poslednji slajd Zaključka.',
      AT_FIRST_SLIDE: 'Ovo je prvi slajd.',
      POLL_ALREADY_OPEN: 'Anketa je već otvorena.',
      INVALID_DURATION: 'Trajanje mora biti između 1 i 360 minuta.',
      TIMER_EXPIRED_USE_RESUME: 'Vreme je isteklo. Za nastavak izaberite opciju u Zaključku i dodajte vreme.',
      RESUME_NEEDS_TIME: 'Vreme je isteklo. Dodajte vreme da biste nastavili.',
      NOTHING_TO_RESUME: 'Nema sekcije na koju se može vratiti.',
      REPEAT_NOT_CONTROLLED: 'Pravilo ponavljanja ove prezentacije ne dozvoljava ručno uključivanje.',
      REOPEN_WINDOW_EXPIRED: 'Predavanje se može ponovo otvoriti samo 15 minuta posle završetka.',
      ANOTHER_SESSION_ACTIVE: 'Za ovu prezentaciju je već pokrenuto drugo predavanje.',
      QUESTION_HIDDEN: 'Sakriveno pitanje se ne može prikazati na projektoru.',
      QUESTION_NOT_FOUND: 'Pitanje ne postoji.',
    },
    keepAwake: 'Ekran ostaje uključen dok je upravljač otvoren.',
  },
  audience: {
    joinTitle: 'Priključite se predavanju',
    joinBody: 'Unesite kod sa projektora.',
    codeLabel: 'Kod predavanja',
    join: 'Priključi se',
    notFound: 'Predavanje sa tim kodom ne postoji.',
    ended: 'Predavanje je završeno. Hvala na učešću!',
    waiting: 'Predavanje uskoro počinje.',
    voteTitle: 'Vaš glas',
    voted: 'Glas je primljen. Možete ga promeniti dok je glasanje otvoreno.',
    closed: 'Glasanje je zatvoreno.',
    results: 'Rezultati',
    nowPresenting: 'Trenutno',
    resultsHidden: 'Rezultati će biti prikazani na projektoru.',
    anonymous: 'Glasanje je anonimno.',
    reactTitle: 'Reakcije',
    reactions: {
      LIKE: 'Sviđa mi se',
      INTERESTING: 'Zanimljivo',
      UNCLEAR: 'Nije jasno',
      MORE_DETAILS: 'Više detalja',
    },
    askTitle: 'Pitanje za predavača',
    askPlaceholder: 'Napišite pitanje (najviše 300 znakova)',
    askSend: 'Pošalji',
    askSent: 'Pitanje je poslato.',
    askAnonymous: 'Pitanje je anonimno. Predavač odlučuje da li se prikazuje na projektoru.',
    editQuestion: 'Izmeni',
    editQuestionLabel: 'Izmena pitanja',
    edited: 'izmenjeno',
    questionStatus: { NEW: 'poslato', ANSWERED: 'odgovoreno', HIDDEN: 'sakriveno' },
    engagementErrors: {
      QUESTION_LOCKED: 'Pitanje više ne može da se menja jer je odgovoreno ili je na projektoru.',
      QUESTION_NOT_FOUND: 'Pitanje nije pronađeno.',
      RATE_LIMITED: 'Malo sporije, pokušajte za koji trenutak.',
      DUPLICATE: 'Već ste poslali isto pitanje.',
      SPAM: 'Pitanje izgleda kao neželjena poruka.',
      TOO_SHORT: 'Pitanje je prekratko.',
      TOO_LONG: 'Pitanje je predugačko.',
      TOO_MANY_QUESTIONS: 'Poslali ste najveći broj pitanja za ovo predavanje.',
      VALIDATION_FAILED: 'Pitanje mora imati od 3 do 300 znakova.',
      NO_SLIDE: 'Reakcije su moguće dok se prikazuje slajd.',
      REACTIONS_DISABLED: 'Reakcije su isključene.',
      QUESTIONS_DISABLED: 'Pitanja su isključena.',
      SESSION_NOT_LIVE: 'Predavanje nije u toku.',
      OFFLINE: 'Nema veze sa serverom.',
      GENERIC: 'Slanje nije uspelo. Pokušajte ponovo.',
    },
  },
  collections: {
    label: 'Oblast',
    presentationLabel: 'Oblast prezentacije',
    presentationHint: 'Builder i birač slajdova prvo nude sekcije i fajlove iz ove oblasti.',
    filter: 'Prikaz po oblasti',
    all: 'Sve',
    none: 'Bez oblasti',
    create: 'Nova oblast',
    createTitle: 'Nova oblast',
    editTitle: 'Izmena oblasti',
    edit: 'Preimenuj ili promeni boju',
    description:
      'Oblast grupiše sekcije, fajlove i prezentacije jednog predmeta ili teme, na primer „Algoritmi i programiranje”.',
    name: 'Naziv',
    namePlaceholder: 'Algoritmi i programiranje',
    color: 'Boja',
    saved: 'Oblast je sačuvana.',
    manage: 'Podešavanja oblasti {{name}}',
    delete: 'Obriši oblast',
    deleteTitle: 'Obrisati oblast „{{name}}”?',
    deleteBody: 'Sekcije, fajlovi i prezentacije ostaju, samo postaju bez oblasti.',
    deleted: 'Oblast je obrisana.',
    moveTitle: 'Premesti u oblast',
    move: 'Premesti',
    moved: 'Premešteno.',
    actionsFor: 'Radnje za {{title}}',
  },
  reports: {
    historyTitle: 'Održana predavanja',
    historySubtitle: 'Svako pokretanje prezentacije, sa izveštajem i izvozom.',
    emptyTitle: 'Još nema održanih predavanja',
    emptyBody: 'Pokrenite sačuvanu prezentaciju i ovde će se pojaviti njen izveštaj.',
    open: 'Izveštaj',
    delete: 'Obriši izveštaj',
    deleteConfirm:
      'Obrisati izveštaj predavanja „{{title}}”? Brišu se glasovi, reakcije i pitanja ovog predavanja.',
    deleted: 'Izveštaj je obrisan.',
    status: { CREATED: 'nije počelo', LIVE: 'u toku', COMPLETED: 'završeno' },
    abandoned: 'završeno automatski posle neaktivnosti',
    exportCsv: 'Izvoz CSV',
    exportPdf: 'Izvoz PDF',
    duration: 'Trajanje',
    plannedMinutes: 'planirano {{minutes}} min',
    uniqueParticipants: 'Jedinstveni učesnici',
    peak: 'najviše {{count}} istovremeno',
    reactions: 'Reakcije',
    questions: 'Pitanja',
    questionsHint: 'odgovoreno {{answered}}, sakriveno {{hidden}}',
    participantsOverTime: 'Povezani učesnici tokom vremena',
    noSamples: 'Nema podataka o povezanim učesnicima.',
    polls: 'Ankete',
    pollState: { OPEN: 'otvorena', CLOSED: 'zatvorena', RESOLVED: 'odlučeno', CANCELLED: 'otkazana' },
    none: 'Nema.',
    actualOrder: 'Stvarni redosled sekcija',
    topic: 'Sekcija',
    plannedPosition: 'Plan',
    entry: 'Ulaz',
    visitStatus: 'Status',
    visitStatuses: { IN_PROGRESS: 'u toku', COMPLETED: 'završeno', INTERRUPTED: 'prekinuto' },
    start: 'Početak',
    minutes: 'Minuti',
    topics: 'Sekcije, vreme i reakcije',
    visits: 'Posete',
    notPresented: 'Neobrađene sekcije',
    decisions: 'Ručne odluke',
    slideReactions: 'Reakcije po slajdu',
    slide: 'Slajd',
    winnerWas: 'pobednik glasanja: {{topics}}',
  },
  surveys: {
    tab: 'Upitnici',
    intro:
      'Upitnici skupljaju utiske publike i ne biraju sledeću sekciju. Umetnut upitnik se otvara kada predavač na izabranom slajdu pređe dalje; ostali se pokreću iz konzole.',
    add: 'Nov upitnik',
    addTemplate: 'Dodaj šablon zadovoljstva',
    empty: 'Još nema upitnika.',
    edit: 'Izmeni upitnik',
    create: 'Nov upitnik',
    delete: 'Obriši upitnik',
    deleteConfirm: 'Obrisati upitnik „{{title}}"?',
    save: 'Sačuvaj upitnik',
    titleLabel: 'Naziv upitnika',
    placement: 'Gde se prikazuje',
    placementManual: 'Ručno, iz konzole',
    placementEnd: 'Na kraju Zaključka, posle poslednjeg slajda',
    placementSlide: 'Posle izabranog slajda',
    section: 'Sekcija',
    slide: 'Slajd',
    slideNumber: 'Slajd {{number}}',
    afterSlide: 'Posle slajda {{number}}, {{section}}',
    atEnd: 'Na kraju Zaključka',
    manual: 'Pokreće se ručno',
    missingPlacement: 'Slajd za ovaj upitnik više ne postoji. Izaberite novo mesto.',
    questions: 'Pitanja',
    addQuestion: 'Dodaj pitanje',
    prompt: 'Pitanje',
    options: 'Ponuđeni odgovori',
    addOption: 'Dodaj odgovor',
    optionLabel: 'Odgovor {{number}}',
    multiple: 'Dozvoli više odgovora',
    correct: 'Tačan',
    ratingMax: 'Skala do',
    ratingStyle: 'Prikaz',
    stars: 'Zvezdice',
    numbers: 'Brojevi',
    maxWords: 'Reči po učesniku',
    moveUp: 'Pomeri gore',
    moveDown: 'Pomeri dole',
    removeQuestion: 'Ukloni pitanje',
    removeOption: 'Ukloni odgovor',
    questionCount_one: '{{count}} pitanje',
    questionCount_few: '{{count}} pitanja',
    questionCount_other: '{{count}} pitanja',
    types: {
      CHOICE: 'Izbor',
      RATING: 'Ocena',
      WORD_CLOUD: 'Oblak reči',
      OPEN_TEXT: 'Otvoren odgovor',
      QUIZ: 'Kviz',
      RANKING: 'Rangiranje',
    },
    typeHints: {
      CHOICE: 'Jedan ili više ponuđenih odgovora, rezultati kao stubići.',
      RATING: 'Ocena na skali, sa prosekom.',
      WORD_CLOUD: 'Reči koje se ponavljaju postaju veće.',
      OPEN_TEXT: 'Slobodan tekst, predavač može da sakrije odgovor.',
      QUIZ: 'Pitanje sa tačnim odgovorom koji otkrivate kad hoćete.',
      RANKING: 'Učesnici ređaju ponuđene stavke po važnosti.',
    },
    card: 'Upitnici',
    launch: 'Pokreni',
    showAgain: 'Prikaži ponovo',
    quick: 'Brzi upitnik',
    quickTitle: 'Brzi upitnik',
    satisfaction: 'Zadovoljstvo predavanjem',
    prepared: 'Pripremljeni upitnici',
    inline: 'umetnut',
    ran: 'održan',
    running: 'Upitnik u toku',
    closedLabel: 'Zatvoren',
    onProjector: 'Na projektoru',
    resultsOnPhones: 'Rezultati na telefonima',
    reveal: 'Otkrij tačan odgovor',
    revealed: 'Tačan odgovor je otkriven',
    close: 'Zatvori upitnik',
    reopen: 'Otvori ponovo',
    hideAnswer: 'Sakrij',
    restoreAnswer: 'Vrati',
    previousQuestion: 'Prethodno pitanje',
    nextQuestion: 'Sledeće pitanje',
    questionOf: 'Pitanje {{current}} od {{total}}',
    responses_one: '{{count}} odgovor',
    responses_few: '{{count}} odgovora',
    responses_other: '{{count}} odgovora',
    respondents_one: '{{count}} učesnik',
    respondents_few: '{{count}} učesnika',
    respondents_other: '{{count}} učesnika',
    average: 'Prosek',
    points: 'poena',
    averagePosition: 'prosečno mesto {{value}}',
    noResponses: 'Još nema odgovora.',
    inlineHint: 'Sledeći slajd zatvara upitnik i nastavlja prezentaciju.',
    projectedNow: 'Upitnik je na projektoru',
    send: 'Pošalji',
    change: 'Promeni odgovor',
    sent: 'Odgovor je poslat.',
    next: 'Sledeće',
    previous: 'Prethodno',
    wordPlaceholder: 'Upišite reč',
    resultPage: 'Strana {{page}} od {{pages}}',
    textPlaceholder: 'Vaš odgovor',
    rankHint: 'Poređajte od najvažnijeg ka najmanje važnom.',
    up: 'Pomeri {{label}} gore',
    down: 'Pomeri {{label}} dole',
    closedNotice: 'Upitnik je zatvoren.',
    allAnswered: 'Hvala! Odgovorili ste na sva pitanja.',
    correctMark: 'tačno',
    conclusionPrompt: 'Pre kraja predavanja pokrenite upitnik o zadovoljstvu.',
    endWarning: 'Upitnik „{{title}}" je još otvoren i biće zatvoren.',
    history: 'Održani upitnici',
    nextSurvey: 'Sledeće: upitnik „{{title}}"',
    continueAfterSurvey: 'Zatvori upitnik i nastavi',
    showSurveyAgain: 'Vrati upitnik na projektor',
    launchFailed: 'Upitnik nije pokrenut.',
    wordCloudEmpty: 'Reči će se pojaviti kad publika odgovori.',
  },
  admin: {
    title: 'Korisnici',
    subtitle: 'Odobravanje naloga, uloge, lozinke i brisanje.',
    add: 'Dodaj korisnika',
    filter: 'Prikaz',
    filters: { PENDING: 'Na čekanju', ACTIVE: 'Aktivni', DISABLED: 'Deaktivirani', ALL: 'Svi' },
    status: { PENDING: 'Na čekanju', ACTIVE: 'Aktivan', DISABLED: 'Deaktiviran' },
    role: { PRESENTER: 'Predavač', ADMIN: 'Administrator' },
    columns: {
      user: 'Korisnik',
      role: 'Uloga',
      status: 'Status',
      created: 'Registrovan',
      lastSeen: 'Poslednja aktivnost',
      content: 'Sadržaj',
      actions: 'Akcije',
    },
    content: '{{presentations}} prez. / {{assets}} fajl.',
    never: 'nikad',
    you: 'vi',
    live: 'drži predavanje',
    empty: 'Nema korisnika u ovom prikazu.',
    pendingNotice_one: '{{count}} nalog čeka odobrenje.',
    pendingNotice_few: '{{count}} naloga čekaju odobrenje.',
    pendingNotice_other: '{{count}} naloga čeka odobrenje.',
    actionsFor: 'Akcije za {{name}}',
    approve: 'Odobri',
    reject: 'Odbij',
    edit: 'Izmeni',
    setPassword: 'Nova lozinka',
    disable: 'Deaktiviraj',
    enable: 'Aktiviraj',
    delete: 'Obriši',
    save: 'Sačuvaj',
    create: 'Napravi nalog',
    generate: 'Generiši',
    approved: 'Nalog {{email}} je odobren.',
    rejected: 'Zahtev {{email}} je odbijen.',
    saved: 'Podaci su sačuvani.',
    created: 'Nalog {{email}} je napravljen.',
    passwordSet: 'Lozinka je promenjena, korisnik je odjavljen sa svih uređaja.',
    disabled: 'Nalog {{email}} je deaktiviran.',
    enabled: 'Nalog {{email}} je aktiviran.',
    deleted: 'Nalog {{email}} je obrisan.',
    editTitle: 'Izmena naloga',
    createTitle: 'Nov korisnik',
    passwordTitle: 'Nova lozinka za {{name}}',
    passwordBody: 'Korisnik se odjavljuje sa svih uređaja. Lozinku mu prosledite sami.',
    disableTitle: 'Deaktivirati nalog?',
    disableBody:
      '{{name}} neće moći da se prijavi, a sadržaj ostaje sačuvan. Nalog može ponovo da se aktivira.',
    rejectTitle: 'Odbiti zahtev?',
    rejectBody: 'Zahtev za nalog {{email}} se briše. Osoba može ponovo da se registruje.',
    deleteTitle: 'Trajno obrisati nalog?',
    deleteBody:
      'Brišu se nalog {{email}} i sav njegov sadržaj: {{presentations}} prezentacija, {{assets}} fajlova, sekcije, oblasti i izveštaji predavanja. Ovo ne može da se poništi.',
    deleteConfirmLabel: 'Za potvrdu upišite email adresu naloga',
  },
  notFound: {
    title: 'Stranica ne postoji',
    body: 'Proverite adresu ili se vratite na početnu.',
    home: 'Na početnu',
  },
};

type DeepStringRecord<T> = { [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]> };
export type TranslationResource = DeepStringRecord<typeof srLatn>;
